export default __webpack_public_path__ + "Flag_of_Spain.gif";